"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bulkUpsertUserPermissionQuerySchema = exports.columnCreditorPermissionsSchema = exports.bulkUpsertUserQuerySchema = exports.columnCreditorAttributesSchema = exports.bulkUpsertUserPermissionSchema = exports.bulkUpsertUserPermissionType = exports.bulkUpsertUserSchema = void 0;
const zod_1 = require("zod");
const string_utils_1 = require("../common/string.utils");
const claims_1 = require("./claims");
exports.bulkUpsertUserSchema = zod_1.z.object({
    external_creditor_id: zod_1.z.string().min(1).max(255).transform(string_utils_1.normalizeCreditor),
    name: zod_1.z.string().min(1).max(255).nullish(),
    email: zod_1.z.string().email().nullish().transform(string_utils_1.normalizeEmail),
    send_invite: zod_1.z.boolean().nullish(),
    active: zod_1.z.boolean().nullish(),
});
exports.bulkUpsertUserPermissionType = zod_1.z.enum([
    claims_1.UsersClaims.CREDITORS_VIEW_PERMISSION,
    'team',
    'profile',
]);
exports.bulkUpsertUserPermissionSchema = zod_1.z.object({
    external_creditor_id: zod_1.z.string().max(255).transform(string_utils_1.normalizeCreditor),
    type: exports.bulkUpsertUserPermissionType,
    value: zod_1.z.string(),
});
exports.columnCreditorAttributesSchema = zod_1.z.object({
    external_creditor_id: zod_1.z.string().min(1).max(255),
    name: zod_1.z.string().min(1).max(255).nullish(),
    email: zod_1.z.string().min(1).max(255).nullish(),
    send_invite: zod_1.z.string().min(1).max(255).nullish(),
    active: zod_1.z.string().min(1).max(255).nullish(),
});
exports.bulkUpsertUserQuerySchema = zod_1.z.object({
    tab_id: zod_1.z.number().int(),
    column_creditor_attributes: exports.columnCreditorAttributesSchema,
});
exports.columnCreditorPermissionsSchema = zod_1.z.object({
    external_creditor_id: zod_1.z.string().min(1).max(255),
    type: exports.bulkUpsertUserPermissionType,
    value: zod_1.z.string().min(1).max(255),
});
exports.bulkUpsertUserPermissionQuerySchema = zod_1.z.object({
    tab_id: zod_1.z.number().int(),
    column_creditor_permissions: exports.columnCreditorPermissionsSchema,
});
